import React from "react";
import ComingSoon from '../../components/ComingSoon/ComingSoon';

const Team = () => {
  return <div><ComingSoon /></div>;
};

export default Team;
